import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import PercentageCalculator from "./PercentageCalculator";
const TITLE =
  "Calculer 45% d'un montant - Calculatrice 45 pour cent - Apprenez combien font 45%";
const DESCRIPTION =
  "Calculer 45% d pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "r 45% d, calculatrice r 45% d, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/45percent/";
function Calculator() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "17px" }}>
                  Comment calculer 45% d'une valeur spécifique :
                </h2>
                <ul>
                  <li>
                    Multipliez la valeur par 45% sous forme de fraction. Le pourcentage 45% peut être représenté comme une fraction de la manière suivante : 45/100.
                  </li>
                  <li>
                    Ensuite, multipliez la valeur originale par la fraction. Supposons que vous ayez une certaine valeur dont vous souhaitez calculer 45%, disons que cette valeur est égale à 100, vous pouvez utiliser l'équation suivante :
                    <br />
                    Le pourcentage = (Valeur originale × Fraction 45/100)
                  </li>
                  <li>
                    Ou vous pouvez simplement effectuer le calcul comme suit : divisez la valeur originale par 2,22.
                    <br />
                    Le pourcentage = Valeur originale / 2,22
                  </li>
                  <li>Vous obtiendrez le pourcentage requis, qui est 45% de la valeur originale.</li>
                </ul>
                <b>
                  Vous pouvez également utiliser la calculatrice électronique suivante pour calculer 45% d'un nombre ou d'un montant spécifique :
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <PercentageCalculator percentage={45} />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />

    </div>
  );
}
export default Calculator;
